module.exports = __webpack_public_path__ + "static/img/American_Credit_Investor_Customer_Voice.c77bb0b.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/imgs/American_Credit_Investor_Customer_Voice.png
// module id = 336
// module chunks = 5